import React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import BasicDateRangePicker from "../Controls/DateRange/BasicDateRangePicker";
import SearchBar from "../Controls/SearchBar/SearchBar";
import Button from "../../components/Controls/Buttons/Button";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import "./actionBars.scss";
import { Badge, Divider, Grid, IconButton } from "@mui/material";
import { action } from "../../constants/action";
import PendingActionsOutlinedIcon from "@mui/icons-material/PendingActionsOutlined";
import { preProRoutes } from "../../routes/routeConstants";

export default function ActionBar(props) {
  const navigate = useNavigate();
  const {
    // steps,
    onSearch,
    filterByDate,
    clear,
    onClickViewPendingBatches,
    list,
  } = props;

  const createNewProject = () => {
    navigate(`/${preProRoutes.newProject}`);
  };

  return (
    <Box className="action-bar">
      <AppBar className="actionbar-bg">
        {/* {steps !== "steppers" ? ( */}
        <Toolbar>
          <Grid container className="action-wrap">
            <Grid item md={2.5}>
              <SearchBar onSearch={(value, type) => onSearch(value, type)} />
            </Grid>

            <Divider
              orientation="vertical"
              flexItem
              sx={{
                m: "4px 20px",
                width: "2px",               
                backgroundColor: "#d3d3d3",     // Optional: darker color for visibility
                borderRadius: "2px"          // Optional: rounded edges
               }}
            />

            <Grid item md={6}>
              <BasicDateRangePicker filterByDate={filterByDate} clear={clear} />
            </Grid>
            <Grid item md={2} style={{ marginLeft: "auto" }}>
              {localStorage.getItem("userRole") === "pre-processor" && (
                <Button
                  text={action.CREATE_PROJECT}
                  className="btn-create-new-project"
                  size="medium"
                  startIcon={<AddIcon />}
                  onClick={createNewProject}
                />
              )}
            </Grid>
            <Grid item style={{ marginLeft: "auto" }}>
              <Badge badgeContent={list?.length} color="primary">
                <IconButton
                  color="primary"
                  aria-label="add to shopping cart"
                  onClick={() => onClickViewPendingBatches()}
                  disabled={!(list?.length > 0)}
                >
                  <PendingActionsOutlinedIcon />
                </IconButton>
              </Badge>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
